export const LABEL_WRAP_WIDTH = 13.2;
export const LABEL_MAX_LINES = 3;
export const LABEL_FIRST_LINE_OFFSET = 16.5;
export const LABEL_LINE_HEIGHT = 12.1;
export const LABEL_BOTTOM_PADDING = 2.2;

export const BAR_WIDTH_RATIO = 0.62;
export const INSIDE_LABEL_MIN_HEIGHT = 28.6;
export const BAR_RADIUS: [number, number, number, number] = [2.2, 2.2, 0, 0];
export const HOVER_DIM_OPACITY = 0.35;

export const CHART_MARGIN_TOP = 19.8;
export const CHART_MARGIN_SIDE = 8.8;
export const ASPECT_RATIO = 560 / 270;
export const EMPTY_STATE_HEIGHT = 220;
